import { formatHrBookingRef } from "../../utils/bookingRefDisplay.js";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function trimStr(v) {
  if (v == null) return "";
  return String(v).trim();
}

function isUuidLike(s) {
  const t = trimStr(s);
  return t.length > 0 && UUID_RE.test(t);
}

/**
 * מספר הזמנה לתצוגה ב-picker / תקציר — ללא יצירת קוד חדש.
 * @param {Record<string, unknown>|null|undefined} order
 * @returns {{ displayNumber: string, orderId: string|null, source: string, internalOrderId: string|null }}
 */
export function resolvePickerOrderDisplayNumber(order) {
  const internalOrderId =
    trimStr(order?.orderId) || trimStr(order?.id) || null;

  if (!order || typeof order !== "object") {
    return {
      displayNumber: "—",
      orderId: internalOrderId,
      source: "empty",
      internalOrderId,
    };
  }

  const displayOrderNumber = trimStr(order.displayOrderNumber);
  if (displayOrderNumber) {
    return {
      displayNumber: displayOrderNumber,
      orderId: internalOrderId,
      source: "displayOrderNumber",
      internalOrderId,
    };
  }

  const hrOrderCode = trimStr(order.hrOrderCode);
  if (hrOrderCode) {
    return {
      displayNumber: hrOrderCode,
      orderId: internalOrderId,
      source: "hrOrderCode",
      internalOrderId,
    };
  }

  const bookingRefRaw =
    order.bookingRef ?? order.raw?.booking_ref ?? order.raw?.bookingRef ?? null;
  const hrFromBookingRef = formatHrBookingRef(bookingRefRaw);
  if (hrFromBookingRef) {
    return {
      displayNumber: hrFromBookingRef,
      orderId: internalOrderId,
      source: "bookingRef_hr",
      internalOrderId,
    };
  }

  const bookingRefText = trimStr(bookingRefRaw);
  if (bookingRefText && !isUuidLike(bookingRefText)) {
    return {
      displayNumber: bookingRefText,
      orderId: internalOrderId,
      source: "bookingRef",
      internalOrderId,
    };
  }

  const orderNumber = trimStr(order.orderNumber);
  if (orderNumber && !isUuidLike(orderNumber)) {
    return {
      displayNumber: orderNumber,
      orderId: internalOrderId,
      source: "orderNumber",
      internalOrderId,
    };
  }

  if (internalOrderId) {
    return {
      displayNumber: internalOrderId,
      orderId: internalOrderId,
      source: "orderId",
      internalOrderId,
    };
  }

  return {
    displayNumber: "—",
    orderId: null,
    source: "fallback",
    internalOrderId: null,
  };
}

/** @param {Record<string, unknown>|null|undefined} order */
export function pickerOrderDisplayNumber(order) {
  return resolvePickerOrderDisplayNumber(order).displayNumber;
}

/**
 * האם להציג שורת מזהה פנימי מתחת לקוד הקריא.
 * @param {{ displayNumber: string, internalOrderId: string|null }} resolved
 */
export function shouldShowPickerInternalOrderId(resolved) {
  const internal = trimStr(resolved?.internalOrderId);
  const display = trimStr(resolved?.displayNumber);
  if (!internal || display === "—") return false;
  if (internal === display) return false;
  if (isUuidLike(internal) && !isUuidLike(display)) return true;
  if (isUuidLike(internal) && isUuidLike(display) && internal !== display) return true;
  return internal !== display;
}
